export const experiments = {
  addToCartButton: {
    id: "add_to_cart_button_color",
    variants: [
      { id: "control", weight: 50 },
      { id: "green", weight: 50 },
    ],
  },
};
